<div class="range_container">
    <div class="sliders_control">
      <div id="fromSliderTooltip" class="slider-tooltip">115</div>
      <input id="fromSlider" type="range" value="25" min="0" max="100" steps="1" />
      <div id="toSliderTooltip" class="slider-tooltip">120</div>
      <input id="toSlider" type="range" value="75" min="0" max="100" steps="1" />
    </div>
    <div id="scale" class="scale" data-steps="50"></div>
  </div>